import { GET_WITH_CREDENTIALS } from '~/api';
import { JiraMeApiUrl } from '~/api/urls';
import { IUser } from '~/domain/IUser';

export const getMe = async () => {
  return GET_WITH_CREDENTIALS<IUser>(JiraMeApiUrl);
}
